var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "polo-area" },
    [
      _c("WindowModal", {
        attrs: { title: _vm.modalTitle, type: "Global" },
        scopedSlots: _vm._u([
          {
            key: "modal-content",
            fn: function () {
              return [
                _c("BuyTickets", {
                  ref: "buyTickets",
                  attrs: {
                    lottery: _vm.lottery,
                    "sold-tickets": _vm.tickets,
                    transaction: _vm.transaction,
                  },
                  on: {
                    buyTickets: _vm.buyTickets,
                    initConfirmState: function ($event) {
                      return _vm.changeModalTitle("init")
                    },
                    initLoading: function ($event) {
                      return _vm.changeModalTitle("loading")
                    },
                    initSuccess: function ($event) {
                      return _vm.changeModalTitle("success")
                    },
                    initError: function ($event) {
                      return _vm.changeModalTitle("error")
                    },
                    closeGlobalModal: _vm.closeModal,
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("WindowModal", {
        attrs: { title: _vm.listTitle, type: "List" },
        scopedSlots: _vm._u([
          {
            key: "modal-content",
            fn: function () {
              return [
                _c("TicketsList", {
                  ref: "ticketsList",
                  attrs: { tickets: _vm.tickets },
                  on: { closeListModal: _vm.closeListModal },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "polo-header" }, [
        _c(
          "picture",
          [
            _c("source", {
              attrs: {
                srcset: "/img/new/water_polo.webp",
                media: "(min-width: 1024px)",
                type: "image/webp",
              },
            }),
            _vm._v(" "),
            _c("source", {
              attrs: {
                srcset: "/img/new/water_polo.png",
                media: "(min-width: 1024px)",
              },
            }),
            _vm._v(" "),
            _c("source", {
              attrs: {
                srcset: "/img/new/water_polo_mobile.webp",
                type: "image/webp",
              },
            }),
            _vm._v(" "),
            _c("nuxt-img", {
              attrs: {
                fit: "inside",
                width: "1600",
                sizes: "sm:650px md:800px lg:1200px xl:1400px xxl:1600px",
                src: "/img/new/water_polo_mobile.png",
                alt: "Earn $FLOATIE and fiat on Defi Pool Finance",
                title: "$FLOATIE lottery",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "texts" }, [
          _c("h1", [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("lottery.water_polo")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "prize-pool" },
            [
              !_vm.lotteryLoading
                ? _c("div", { staticClass: "h2" }, [
                    _vm._v(
                      "\n          $ " +
                        _vm._s(
                          _vm.$priceFormat(
                            _vm.floatieToUsd(
                              _vm.lottery.amountCollectedInFloatie
                            ),
                            2
                          )
                        ) +
                        "\n        "
                    ),
                  ])
                : _c("skeleton", {
                    staticClass: "h2",
                    attrs: { width: "300px", height: "60px" },
                  }),
              _vm._v(" "),
              _c("div", { staticClass: "h6" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("lottery.in_prizes")) +
                    "\n        "
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("lottery.guess_desc")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _vm.lotteryActive
            ? _c("div", { staticClass: "buttons-area" }, [
                _vm.user !== null
                  ? _c(
                      "button",
                      {
                        staticClass: "btn pink",
                        attrs: { type: "button" },
                        on: { click: _vm.openBuyModal },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("lottery.buy_tickets_cta")) +
                            "\n        "
                        ),
                      ]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "btn pink",
                        attrs: { type: "button" },
                        on: { click: _vm.openConnectModal },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("common.connect_wallet")) +
                            "\n        "
                        ),
                      ]
                    ),
              ])
            : _c("div", { staticClass: "buttons-area" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn pink",
                    attrs: { type: "button" },
                    on: { click: _vm.scrollToResults },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("lottery.see_recent")) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { ref: "resultsSection", staticClass: "lottery-area" }, [
        _c("div", { staticClass: "left" }, [
          _c("div", { staticClass: "heading" }, [
            _vm.lotteryActive
              ? _c("div", { staticClass: "h3" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("lottery.buy_tickets")) +
                      "\n        "
                  ),
                ])
              : _c("div", { staticClass: "h3" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("lottery.buy_tickets_later")) +
                      "\n        "
                  ),
                ]),
            _vm._v(" "),
            _vm.lotteryActive
              ? _c("div", { staticClass: "timer" }, [
                  _c(
                    "div",
                    { staticClass: "number days" },
                    [
                      !_vm.lotteryLoading
                        ? _c("p", { staticClass: "text" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.drawTimeLeft("days")) +
                                "\n            "
                            ),
                          ])
                        : _c("Skeleton", {
                            staticClass: "text",
                            attrs: { width: "53px", height: "38px" },
                          }),
                      _vm._v(" "),
                      _c("p", { staticClass: "desc" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("common.days")) +
                            "\n            "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "separate" }, [
                    _vm._v("\n            :\n          "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "number hours" },
                    [
                      !_vm.lotteryLoading
                        ? _c("p", { staticClass: "text" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.drawTimeLeft("hours")) +
                                "\n            "
                            ),
                          ])
                        : _c("Skeleton", {
                            staticClass: "text",
                            attrs: { width: "53px", height: "38px" },
                          }),
                      _vm._v(" "),
                      _c("p", { staticClass: "desc" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("common.hours")) +
                            "\n            "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "separate" }, [
                    _vm._v("\n            :\n          "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "number minutes" },
                    [
                      !_vm.lotteryLoading
                        ? _c("p", { staticClass: "text" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.drawTimeLeft("minutes")) +
                                "\n            "
                            ),
                          ])
                        : _c("Skeleton", {
                            staticClass: "text",
                            attrs: { width: "53px", height: "38px" },
                          }),
                      _vm._v(" "),
                      _c("p", { staticClass: "desc" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("common.minutes")) +
                            "\n            "
                        ),
                      ]),
                    ],
                    1
                  ),
                ])
              : _c("div", { staticClass: "timer" }, [
                  _c("div", { staticClass: "header" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("lottery.calculating_results")) +
                        "...\n          "
                    ),
                  ]),
                ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "accordion-box" }, [
            _c("div", { staticClass: "header" }, [
              _vm.lotteryActive
                ? _c("div", { staticClass: "h4" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("lottery.next_draw")) +
                        "\n          "
                    ),
                  ])
                : _c("div", { staticClass: "h4" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("lottery.current_draw")) +
                        "\n          "
                    ),
                  ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "details" },
                [
                  !_vm.lotteryLoading
                    ? _c("p", [
                        _vm._v(
                          "\n              # " +
                            _vm._s(_vm.lottery.id) +
                            "\n            "
                        ),
                      ])
                    : _c("Skeleton", {
                        attrs: { width: "40px", height: "14px" },
                      }),
                  _vm._v(" "),
                  _vm.lotteryActive
                    ? _c("p", [_vm._v("\n               | \n            ")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.lotteryActive
                    ? _c("p", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("lottery.draw")) +
                            ": \n            "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.lotteryLoading && _vm.lotteryActive
                    ? _c("p", [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$stringifyDate(_vm.lottery.endTime, true)
                            ) +
                            "\n            "
                        ),
                      ])
                    : _vm.lotteryActive
                    ? _c("Skeleton", {
                        attrs: { width: "175px", height: "14px" },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "prize-pot" }, [
              _vm.lotteryActive
                ? _c(
                    "div",
                    { staticClass: "number-area" },
                    [
                      _c("div", { staticClass: "h6" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("lottery.prize_pot")) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      !_vm.lotteryLoading
                        ? _c("div", { staticClass: "usd" }, [
                            _vm._v(
                              "\n              ~$" +
                                _vm._s(
                                  _vm.$priceFormat(
                                    _vm.floatieToUsd(
                                      _vm.lottery.amountCollectedInFloatie
                                    ),
                                    2
                                  )
                                ) +
                                "\n            "
                            ),
                          ])
                        : _c("Skeleton", {
                            staticClass: "usd",
                            attrs: { width: "180px", height: "39px" },
                          }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "crypto" },
                        [
                          _c(
                            "div",
                            { staticClass: "floatie" },
                            [_c("FloatieLogo")],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.lotteryLoading
                            ? _c("p", { staticClass: "number" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.lottery.amountCollectedInFloatie
                                    ) +
                                    " " +
                                    _vm._s(_vm.floatie.symbol.toUpperCase()) +
                                    "\n              "
                                ),
                              ])
                            : _c("Skeleton", {
                                staticClass: "number",
                                attrs: { width: "80px", height: "14px" },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c("div", { staticClass: "number-area" }, [
                    _c("div", { staticClass: "h6" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("lottery.prize_pot")) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "usd" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("lottery.calculating")) +
                          "...\n            "
                      ),
                    ]),
                  ]),
              _vm._v(" "),
              _c("div", { staticClass: "tickets-area" }, [
                _vm.tickets.length > 0 && _vm.user !== null
                  ? _c(
                      "div",
                      {
                        staticClass: "h6 cursor-pointer",
                        on: { click: _vm.openListModal },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("lottery.show_tickets", {
                                tickets: _vm.tickets.length,
                                tickets_text: _vm.$numberToString(
                                  _vm.tickets.length,
                                  [
                                    _vm.$t("lottery.ticket"),
                                    _vm.$t("lottery.tickets"),
                                    _vm.$t("lottery.many_tickets"),
                                  ]
                                ),
                              })
                            ) +
                            "\n            "
                        ),
                      ]
                    )
                  : _c("div", { staticClass: "h6" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("lottery.your_tickets")) +
                          "\n            "
                      ),
                    ]),
                _vm._v(" "),
                _vm.lotteryActive
                  ? _c("div", { staticClass: "buttons-area" }, [
                      _vm.user !== null
                        ? _c(
                            "button",
                            {
                              staticClass: "btn pink",
                              attrs: { type: "button" },
                              on: { click: _vm.openBuyModal },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("lottery.buy_tickets_cta")) +
                                  "\n              "
                              ),
                            ]
                          )
                        : _c(
                            "button",
                            {
                              staticClass: "btn pink",
                              attrs: { type: "button" },
                              on: { click: _vm.openConnectModal },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("common.connect_wallet")) +
                                  "\n              "
                              ),
                            ]
                          ),
                    ])
                  : _c("div", { staticClass: "buttons-area" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn pink disabled",
                          attrs: { type: "button", disabled: "" },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("lottery.on_sale_soon")) +
                              "\n              "
                          ),
                        ]
                      ),
                    ]),
              ]),
            ]),
            _vm._v(" "),
            _c("hr", { staticClass: "reverse" }),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "accordion1",
                class: { accordion: true, active: _vm.accordions.accordion1 },
              },
              [
                _c(
                  "div",
                  { ref: "accordionArea1", staticClass: "accordion-area" },
                  [
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("lottery.match_text")) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "match-list" },
                      [
                        _vm._l(6, function (index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "match" },
                            [
                              _c("div", { staticClass: "h6" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      (index + 1 !== 6
                                        ? _vm.$t("lottery.match_first")
                                        : _vm.$t("lottery.match_all")) +
                                        " " +
                                        index
                                    ) +
                                    "\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              !_vm.lotteryLoading
                                ? _c("div", { staticClass: "h4" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.grabAmount("current", index) +
                                            " " +
                                            _vm.floatie.symbol.toUpperCase()
                                        ) +
                                        "\n                "
                                    ),
                                  ])
                                : _c("Skeleton", {
                                    staticClass: "h4",
                                    attrs: { width: "100px", height: "20px" },
                                  }),
                              _vm._v(" "),
                              !_vm.lotteryLoading
                                ? _c("p", { staticClass: "usd" }, [
                                    _vm._v(
                                      "\n                  ~$" +
                                        _vm._s(
                                          _vm.$priceFormat(
                                            _vm.floatieToUsd(
                                              _vm.grabAmount("current", index)
                                            ),
                                            2
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ])
                                : _c("Skeleton", {
                                    staticClass: "usd",
                                    attrs: { width: "70px", height: "14px" },
                                  }),
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "match burned" },
                          [
                            _c("div", { staticClass: "h6" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("lottery.burn")) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            !_vm.lotteryLoading
                              ? _c("div", { staticClass: "h4" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.getBurnAmount("current") +
                                          " " +
                                          _vm.floatie.symbol.toUpperCase()
                                      ) +
                                      "\n                "
                                  ),
                                ])
                              : _c("Skeleton", {
                                  staticClass: "h4",
                                  attrs: { width: "100px", height: "20px" },
                                }),
                            _vm._v(" "),
                            !_vm.lotteryLoading
                              ? _c("p", { staticClass: "usd" }, [
                                  _vm._v(
                                    "\n                  ~$" +
                                      _vm._s(
                                        _vm.$priceFormat(
                                          _vm.floatieToUsd(
                                            _vm.getBurnAmount("current")
                                          ),
                                          2
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ])
                              : _c("Skeleton", {
                                  staticClass: "usd",
                                  attrs: { width: "70px", height: "14px" },
                                }),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "accordionHeader1",
                    staticClass: "accordion-header",
                    on: {
                      click: function ($event) {
                        return _vm.openAccordion(1)
                      },
                    },
                  },
                  [
                    _vm.accordions.accordion1
                      ? _c("p", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("common.hide")) +
                              "\n            "
                          ),
                        ])
                      : _c("p", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("lottery.details")) +
                              "\n            "
                          ),
                        ]),
                    _vm._v(" "),
                    _c("ChevronDown"),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _c("div", { staticClass: "heading" }, [
            _c("div", { staticClass: "h3" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("lottery.finished")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "range-switch-area" }, [
              _c(
                "div",
                {
                  class: {
                    "switch-item": true,
                    active: _vm.history.filter === "all",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeHistoryTab("all")
                    },
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("lottery.all_history")) +
                        "\n            "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    "switch-item": true,
                    active: _vm.history.filter === "user",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeHistoryTab("user")
                    },
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("lottery.your_history")) +
                        "\n            "
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "accordion-box" }, [
            _c(
              "div",
              { staticClass: "header" },
              [
                !_vm.lotteryPrevLoading
                  ? _c("div", { staticClass: "h4" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("lottery.round") + " #" + _vm.lotteryPrev.id
                          ) +
                          "\n          "
                      ),
                    ])
                  : _c("Skeleton", {
                      staticClass: "h4",
                      attrs: { width: "100px", height: "16px" },
                    }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "details" },
                  [
                    _c("p", [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("lottery.drawn")) +
                          ": \n            "
                      ),
                    ]),
                    _vm._v(" "),
                    !_vm.lotteryPrevLoading
                      ? _c("p", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$stringifyDate(
                                  _vm.lotteryPrev.endTime,
                                  true
                                )
                              ) +
                              "\n            "
                          ),
                        ])
                      : _c("Skeleton", {
                          attrs: { width: "165px", height: "14px" },
                        }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "winning-number" }, [
              _c("div", { staticClass: "h6" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("lottery.winning_number")) +
                    "\n            "
                ),
                _c("span", { staticClass: "color" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("lottery.latest")) +
                      "\n            "
                  ),
                ]),
              ]),
              _vm._v(" "),
              !_vm.lotteryPrevLoading
                ? _c(
                    "div",
                    { staticClass: "numbers" },
                    _vm._l(6, function (index) {
                      return _c(
                        "div",
                        { key: index, class: ["number", "color" + index] },
                        [
                          _c("p", [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.wonNumber(index)) +
                                "\n              "
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  )
                : _c(
                    "div",
                    { staticClass: "numbers" },
                    _vm._l(6, function (index) {
                      return _c(
                        "div",
                        { key: index, class: ["number", "color" + index] },
                        [
                          _c("Skeleton", {
                            attrs: { width: "20px", height: "30px" },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
            ]),
            _vm._v(" "),
            _c("hr", { staticClass: "reverse" }),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "accordion2",
                class: { accordion: true, active: _vm.accordions.accordion2 },
              },
              [
                _c(
                  "div",
                  { ref: "accordionArea2", staticClass: "accordion-area" },
                  [
                    _c("div", { staticClass: "pot-results" }, [
                      _c(
                        "div",
                        { staticClass: "totals" },
                        [
                          _c("div", { staticClass: "h6" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("lottery.prize_pot")) +
                                "\n                "
                            ),
                          ]),
                          _vm._v(" "),
                          !_vm.lotteryPrevLoading
                            ? _c("div", { staticClass: "usd" }, [
                                _vm._v(
                                  "\n                  ~$" +
                                    _vm._s(
                                      _vm.$priceFormat(
                                        _vm.floatieToUsd(
                                          _vm.lotteryPrev
                                            .amountCollectedInFloatie
                                        ),
                                        2
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ])
                            : _c("Skeleton", {
                                staticClass: "usd",
                                attrs: { width: "145px", height: "31px" },
                              }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "crypto" },
                            [
                              _c(
                                "div",
                                { staticClass: "floatie" },
                                [_c("FloatieLogo")],
                                1
                              ),
                              _vm._v(" "),
                              !_vm.lotteryPrevLoading
                                ? _c("p", { staticClass: "number" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.lotteryPrev
                                            .amountCollectedInFloatie
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.floatie.symbol.toUpperCase()
                                        ) +
                                        "\n                  "
                                    ),
                                  ])
                                : _c("Skeleton", {
                                    staticClass: "number",
                                    attrs: { width: "80px", height: "14px" },
                                  }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "h6" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("lottery.total_players")) +
                                "\n                "
                            ),
                          ]),
                          _vm._v(" "),
                          !_vm.lotteryPrevLoading
                            ? _c("p", { staticClass: "number" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.getTotalPlayers) +
                                    "\n                "
                                ),
                              ])
                            : _c("Skeleton", {
                                staticClass: "number",
                                attrs: { width: "23px", height: "14px" },
                              }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "grabs" }, [
                        _c("p", { staticClass: "desc" }, [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.$t("lottery.match_text")) +
                              "\n                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "match-list" },
                          [
                            _vm._l(6, function (index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "match" },
                                [
                                  _c("div", { staticClass: "h6" }, [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          (index + 1 !== 6
                                            ? _vm.$t("lottery.match_first")
                                            : _vm.$t("lottery.match_all")) +
                                            " " +
                                            index
                                        ) +
                                        "\n                    "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  !_vm.lotteryPrevLoading
                                    ? _c("div", { staticClass: "h4" }, [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.grabAmount("old", index) +
                                                " " +
                                                _vm.floatie.symbol.toUpperCase()
                                            ) +
                                            "\n                    "
                                        ),
                                      ])
                                    : _c("Skeleton", {
                                        staticClass: "h4",
                                        attrs: {
                                          width: "100px",
                                          height: "20px",
                                        },
                                      }),
                                  _vm._v(" "),
                                  !_vm.lotteryPrevLoading
                                    ? _c("p", { staticClass: "usd" }, [
                                        _vm._v(
                                          "\n                      ~$" +
                                            _vm._s(
                                              _vm.$priceFormat(
                                                _vm.floatieToUsd(
                                                  _vm.grabAmount("old", index)
                                                ),
                                                2
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ])
                                    : _c("Skeleton", {
                                        staticClass: "usd",
                                        attrs: {
                                          width: "70px",
                                          height: "14px",
                                        },
                                      }),
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "match burned" },
                              [
                                _c("div", { staticClass: "h6" }, [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.$t("lottery.burn")) +
                                      "\n                    "
                                  ),
                                ]),
                                _vm._v(" "),
                                !_vm.lotteryPrevLoading
                                  ? _c("div", { staticClass: "h4" }, [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.getBurnAmount("old") +
                                              " " +
                                              _vm.floatie.symbol.toUpperCase()
                                          ) +
                                          "\n                    "
                                      ),
                                    ])
                                  : _c("Skeleton", {
                                      staticClass: "h4",
                                      attrs: { width: "100px", height: "20px" },
                                    }),
                                _vm._v(" "),
                                !_vm.lotteryPrevLoading
                                  ? _c("p", { staticClass: "usd" }, [
                                      _vm._v(
                                        "\n                      ~$" +
                                          _vm._s(
                                            _vm.$priceFormat(
                                              _vm.floatieToUsd(
                                                _vm.getBurnAmount("old")
                                              ),
                                              2
                                            )
                                          ) +
                                          "\n                    "
                                      ),
                                    ])
                                  : _c("Skeleton", {
                                      staticClass: "usd",
                                      attrs: { width: "70px", height: "14px" },
                                    }),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "accordionHeader2",
                    staticClass: "accordion-header",
                    on: {
                      click: function ($event) {
                        return _vm.openAccordion(2)
                      },
                    },
                  },
                  [
                    _vm.accordions.accordion2
                      ? _c("p", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("common.hide")) +
                              "\n            "
                          ),
                        ])
                      : _c("p", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("lottery.details")) +
                              "\n            "
                          ),
                        ]),
                    _vm._v(" "),
                    _c("ChevronDown"),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.user === null
        ? _c("div", { staticClass: "win-area" }, [
            _c(
              "picture",
              [
                _c("source", {
                  attrs: {
                    srcset: "/img/new/connect_wallet.webp",
                    type: "image/webp",
                  },
                }),
                _vm._v(" "),
                _c("nuxt-img", {
                  attrs: {
                    fit: "inside",
                    width: "2188",
                    sizes: "sm:250px md:300px lg:400px xl:500px xxl:600px",
                    src: "/img/new/connect_wallet.png",
                    alt: "Connect wallet to earn prize on Defi Pool Finance",
                    title: "Connect wallet",
                    loading: "lazy",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "h2" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("lottery.connect_wallet")) + "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "buttons-area" }, [
              _c(
                "button",
                {
                  staticClass: "btn cyan",
                  attrs: { type: "button" },
                  on: { click: _vm.openConnectModal },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("common.connect_wallet")) +
                      "\n      "
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "howto-area" }, [
        _c("div", { staticClass: "h3" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("lottery.hot_to_play_title")) + "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "desc" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("lottery.hot_to_play_desc")) + "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "items" }, [
          _c("div", { staticClass: "item" }, [
            _c(
              "picture",
              [
                _c("source", {
                  attrs: {
                    srcset: "/img/new/tickets.webp",
                    type: "image/webp",
                  },
                }),
                _vm._v(" "),
                _c("nuxt-img", {
                  attrs: {
                    fit: "inside",
                    width: "3851",
                    sizes: "sm:250px md:275px lg:300px xl:400px xxl:500px",
                    src: "/img/new/tickets.png",
                    alt: "Buy lottery tickets to earn and win on Defi Pool Finance",
                    title: "Buy lottery tickets",
                    loading: "lazy",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-area" }, [
              _c("div", { staticClass: "h6" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("lottery.buy_tickets_header")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("lottery.buy_tickets_desc")) +
                    "\n          "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item" }, [
            _c(
              "picture",
              [
                _c("source", {
                  attrs: {
                    srcset: "/img/new/calendar.webp",
                    type: "image/webp",
                  },
                }),
                _vm._v(" "),
                _c("nuxt-img", {
                  attrs: {
                    fit: "inside",
                    width: "2113",
                    sizes: "sm:250px md:275px lg:300px xl:400px xxl:500px",
                    src: "/img/new/calendar.png",
                    alt: "Plan your crypto income with Defi Pool Finance",
                    title: "Wait the draw",
                    loading: "lazy",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-area" }, [
              _c("div", { staticClass: "h6" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("lottery.wait_draw_header")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("lottery.wait_draw_desc")) +
                    "\n          "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item" }, [
            _c(
              "picture",
              [
                _c("source", {
                  attrs: { srcset: "/img/new/prize.webp", type: "image/webp" },
                }),
                _vm._v(" "),
                _c("nuxt-img", {
                  attrs: {
                    fit: "inside",
                    width: "1464",
                    sizes: "sm:250px md:275px lg:300px xl:400px xxl:500px",
                    src: "/img/new/prize.png",
                    alt: "Win biggest crypto prize on Defi Pool Finance",
                    title: "Win prize",
                    loading: "lazy",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-area" }, [
              _c("div", { staticClass: "h6" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("lottery.check_prizes_header")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("lottery.check_prizes_desc")) +
                    "\n          "
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "winning-area" }, [
        _c("div", { staticClass: "text-area" }, [
          _c("div", { staticClass: "h3" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("lottery.criteria_winning")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("lottery.criteria_winning_p1")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "icon-text" },
            [
              _c("CheckFilled"),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("lottery.criteria_winning_p2")) +
                    "\n        "
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "icon-text" },
            [
              _c("CheckFilled"),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("lottery.criteria_winning_p3")) +
                    "\n        "
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("lottery.criteria_winning_p4")) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "schema-area" }, [
          _c(
            "div",
            { staticClass: "numbers" },
            [
              _c("div", { staticClass: "item-area" }),
              _vm._v(" "),
              _vm._l(
                _vm.exampleNumbers.lottery.split(""),
                function (number, index) {
                  return _c("div", { key: index, staticClass: "item-area" }, [
                    _c("div", { class: ["number", "color" + (index + 1)] }, [
                      _c("p", [
                        _vm._v(
                          "\n              " + _vm._s(number) + "\n            "
                        ),
                      ]),
                    ]),
                  ])
                }
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "icons-row" },
            [
              _c("div", { staticClass: "item-area" }),
              _vm._v(" "),
              _vm._l(6, function (index) {
                return _c("div", { key: index, staticClass: "item-area" }, [
                  index < 5 || index > 5
                    ? _c(
                        "div",
                        { staticClass: "check" },
                        [_c("CheckOutline")],
                        1
                      )
                    : _c("div", { staticClass: "cross" }, [_c("Plus")], 1),
                ])
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tickets-row mr-4" },
            [
              _c("div", { staticClass: "item-area" }, [
                _vm._v("\n          A\n        "),
              ]),
              _vm._v(" "),
              _vm._l(
                _vm.exampleNumbers.ticketA.split(""),
                function (number, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      class: {
                        "item-area": true,
                        bordered: index < 4,
                        disabled: index > 3,
                        first: index === 0,
                        last: index === 3,
                      },
                    },
                    [
                      _c("div", { staticClass: "ticket-number" }, [
                        _c("p", [
                          _vm._v(
                            "\n              " +
                              _vm._s(number) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ]
                  )
                }
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "icons-row" },
            [
              _c("div", { staticClass: "item-area" }),
              _vm._v(" "),
              _vm._l(6, function (index) {
                return _c("div", { key: index, staticClass: "item-area" }, [
                  index !== 1
                    ? _c(
                        "div",
                        { staticClass: "check" },
                        [_c("CheckOutline")],
                        1
                      )
                    : _c("div", { staticClass: "cross" }, [_c("Plus")], 1),
                ])
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tickets-row" },
            [
              _c("div", { staticClass: "item-area" }, [
                _vm._v("\n          B\n        "),
              ]),
              _vm._v(" "),
              _vm._l(
                _vm.exampleNumbers.ticketB.split(""),
                function (number, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "item-area disabled" },
                    [
                      _c("div", { staticClass: "ticket-number disabled" }, [
                        _c("p", [
                          _vm._v(
                            "\n              " +
                              _vm._s(number) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ]
                  )
                }
              ),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("hr", { staticClass: "divider" }),
      _vm._v(" "),
      _c("div", { staticClass: "funds-area" }, [
        _c("div", { staticClass: "text-area" }, [
          _c("div", { staticClass: "h3" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("lottery.prize_fund_header")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("lottery.prize_fund_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("lottery.ticket_purchases_header")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "icon-text" },
            [
              _c("CheckFilled"),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("lottery.ticket_purchases_desc")) +
                    "\n        "
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "h6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("lottery.rollover_prizes_header")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "icon-text" },
            [
              _c("CheckFilled"),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("lottery.rollover_prizes_desc")) +
                    "\n        "
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "h6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("lottery.injections_header")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "icon-text" },
            [
              _c("CheckFilled"),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("lottery.injections_desc")) +
                    "\n        "
                ),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "table-area" }, [
          _c(
            "div",
            { staticClass: "matches" },
            [
              _c("div", { staticClass: "h6" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("lottery.digits_matched")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _vm._l(6, function (index) {
                return _c("div", { key: index, staticClass: "match" }, [
                  _c("div", { class: ["number", "color" + index] }),
                  _vm._v(" "),
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          (index !== 6
                            ? _vm.$t("lottery.match_first")
                            : _vm.$t("lottery.match_all")) +
                            " " +
                            index
                        ) +
                        "\n          "
                    ),
                  ]),
                ])
              }),
            ],
            2
          ),
          _vm._v(" "),
          !_vm.lotteryLoading
            ? _c(
                "div",
                { staticClass: "percent" },
                [
                  _c("div", { staticClass: "h6" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("lottery.prize_pool_allocation")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(6, function (index) {
                    return _c("div", { key: index, staticClass: "value" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$priceFormat(
                              parseFloat(
                                _vm.lottery.rewardsBreakdown[index - 1]
                              ) / 100,
                              1
                            )
                          ) +
                          "%\n        "
                      ),
                    ])
                  }),
                ],
                2
              )
            : _c(
                "div",
                { staticClass: "percent" },
                [
                  _c("div", { staticClass: "h6" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("lottery.prize_pool_allocation")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(6, function (index) {
                    return _c("Skeleton", {
                      key: index,
                      staticClass: "value",
                      attrs: { width: "75px", height: "21px" },
                    })
                  }),
                ],
                2
              ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }